export const HOT_DEAL_ENABLED = 'HOT_DEAL_ENABLED'
export const HOT_DEAL_URL = 'HOT_DEAL_URL'

export default {
  loan: ({ loan }) => {
    return (
      loan || {
        content_date: '2025-10-22T17:00:00.000Z',
        banks: [
          {
            id: 1,
            translations: [
              { lang: 'th', name: 'กรุงไทย' },
              { lang: 'en', name: 'Krungthai Bank' },
            ],
            image_url: '/images/bank/ktb.png',
            interest_rate: 0.033,
            loan_limit: 100,
            loan_period: 40,
          },
          {
            id: 2,
            translations: [
              { lang: 'th', name: 'ทหารไทยธนชาต' },
              { lang: 'en', name: 'TMBThanachart Bank' },
            ],
            image_url: '/images/bank/ttb.png',
            interest_rate: 0.045,
            loan_limit: 100,
            loan_period: 35,
          },
          {
            id: 3,
            translations: [
              { lang: 'th', name: 'กรุงศรีอยุธยา' },
              { lang: 'en', name: 'Bank of Ayudhya' },
            ],
            image_url: '/images/bank/bay.png',
            interest_rate: 0.0465,
            loan_limit: 100,
            loan_period: 30,
          },
          {
            id: 4,
            translations: [
              { lang: 'th', name: 'กรุงเทพ' },
              { lang: 'en', name: 'Bangkok Bank' },
            ],
            image_url: '/images/bank/bbl.png',
            interest_rate: 0.0315,
            loan_limit: 100,
            loan_period: 30,
          },
          {
            id: 5,
            translations: [
              { lang: 'th', name: 'อาคารสงเคราะห์' },
              { lang: 'en', name: 'Government Housing Bank' },
            ],
            image_url: '/images/bank/gh.png',
            interest_rate: 0.0339,
            loan_limit: 100,
            loan_period: 40,
          },
          {
            id: 6,
            translations: [
              { lang: 'th', name: 'ออมสิน' },
              { lang: 'en', name: 'Government Savings Bank' },
            ],
            image_url: '/images/bank/gsb.png',
            interest_rate: 0.0345,
            loan_limit: 110,
            loan_period: 40,
          },
          {
            id: 7,
            translations: [
              { lang: 'th', name: 'ไทยพาณิชย์' },
              { lang: 'en', name: 'Siam Commercial Bank' },
            ],
            image_url: '/images/bank/scb.png',
            interest_rate: 0.0364,
            loan_limit: 100,
            loan_period: 30,
          },
          {
            id: 8,
            translations: [
              { lang: 'th', name: 'กสิกรไทย' },
              { lang: 'en', name: 'Kasikornbank' },
            ],
            image_url: '/images/bank/kbank.png',
            interest_rate: 0.0312,
            loan_limit: 100,
            loan_period: 30,
          },
          {
            id: 9,
            translations: [
              { lang: 'th', name: 'ยูโอบี' },
              { lang: 'en', name: 'United Overseas Bank' },
            ],
            image_url: '/images/bank/uob.png',
            interest_rate: 0.031,
            loan_limit: 100,
            loan_period: 30,
          },
          {
            id: 10,
            translations: [
              { lang: 'th', name: 'แลนด์ แอนด์ เฮ้าส์' },
              { lang: 'en', name: 'Land and Houses Bank' },
            ],
            image_url: '/images/bank/lh.png',
            interest_rate: 0.0317,
            loan_limit: 110,
            loan_period: 35,
          },
        ],
      }
    ) // mock
  },
}
